//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*
|---------------------------------------------------------------------
| Sign Up Page Component
|---------------------------------------------------------------------
|
| Template for user sign up with external providers buttons
|
*/
import { mapGetters, mapActions } from 'vuex';
// import { signupCustomerUser } from '@/api/auth';
// import { fetchAllCodes } from '@/api/codes';
// import { regExp } from '@/utils/regExpress';
export default {
	data() {
		return {
			// sign up buttons
			isLoading: false,
			isSignUpDisabled: false,
			// form
			isFormValid: true,
			username: '',
			password: '',
			email: '',
			partnerMallId: process.env.partnerMallId,
			customerShopClass: '사업자',

			shopName: '',
			tellNumber: '',
			cellNumber: '',
			businessName: '',
			businessPerson: '',
			businessNumber: '',
			vBankCode: null,
			accountNumber: '',
			accountHolder: '',
			charger: '',
			city: '',
			street: '',
			zipcode: '',
			customerOnOffClass: '온라인',
			bulkYn: 'Y', // 디디엠마켓몰은 Y, 도매상몰은 N
			relativeCompany: 'ISHOES', // 디디엠마켓몰은 ISHOES, 도매상몰은 DDM
			fax: '',
			homepage: '',
			customerMemo: '',
			joinChannel: '',
			customerClient: [],
			operationPeriod: '',
			mainBuying: [],

			logMessage: '',
			// form error
			errorName: false,
			errorEmail: false,
			errorPassword: false,
			errorShopName: false,
			errorTellNumber: false,
			errorCellNumber: false,
			errorBusinessName: false,
			errorBusinessPerson: false,
			errorBusinessNumber: false,
			errorBankName: false,
			errorAccountNumber: false,
			errorAccountHolder: false,
			errorCharger: false,
			errorCity: false,
			errorStreet: false,
			errorZipcode: false,
			errorHomepage: false,
			errorFax: false,
			errorProvider: false,
			errorProviderMessages: '',
			// show password field
			showPassword: false,
			postWindow: null,
			postOpen: false,
			rules: {
				required: v => !!v || '입력하세요!',
				counter: v => v.length <= 20 || '20자 이내로 입력하세요!',
				usernameRule: [
					v => !!v || '대표 아이디는 필수 입력사항입니다.',
					v => !(v && (v.length < 5 || v.length > 20)) || '아이디는 4~20자 이내로 입력하세요!',
					v => !/[~!@#$%^&*()_+|<>?:{}]/.test(v) || '아이디는 특수문자를 사용할 수 없습니다.',
					v => {
						const pattern = /^[a-zA-Z0-9]+$/;
						return pattern.test(v) || '아이디 형식이 아닙니다. (.특수기호, 한글 제외!)';
					},
				],
				passwordRule: [
					v => !!v || '비밀번호는 필수 입력사항입니다.',
					v => !(v && (v.length < 6 || v.length > 20)) || '비밀번호는 6~20자 이내로 입력하세요!',
				],
				shopNameRule: [
					v => !!v || '매장명은 필수 입력사항입니다.',
					v => !(v && v.length > 50) || '매장명은 50자 이상 입력할 수 없습니다.',
					v => !/[~!@#$%^&*_+|<>?:{}]/.test(v) || '매장명은 특수문자를 사용할 수 없습니다.',
				],
				phoneNumber: [
					v => !(v && v.length > 20) || '20자 이상 입력할 수 없습니다.',
					v => {
						const pattern = /^[0123456789-]+$/;
						return pattern.test(v) || '입력 형식이 아닙니다. (숫자와 하이픈(-)만 입력 가능합니다.)';
					},
				],
				email: v => {
					const pattern =
						/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					// const pattern = /.+@.+\..+/
					return pattern.test(v) || '이메일 형식이 아닙니다';
				},
				min(min, v) {
					return (v || '').length >= min || `최소 ${min} 자리 이상 입력하세요!`;
				},
				max(max, v) {
					return (v || '').length <= max || `최소 ${max} 자리 이하 입력하세요!`;
				},
				hyphennumber: v => {
					const pattern = /^[0123456789-]+$/;
					return pattern.test(v) || '입력 형식이 아닙니다. (숫자와 하이픈(-)만 입력하세요)';
				},
				number: v => {
					const pattern = /^[0-9]+$/;
					return pattern.test(v) || '숫자 형식이 아닙니다. (특수기호, 한글, 영문 제외!)';
				},
				englishNumber: v => {
					const pattern = /^[a-zA-Z0-9]+$/;
					return pattern.test(v) || '아이디 형식이 아닙니다. (.특수기호, 한글 제외!)';
				},
			},
			emailRules: [
				v => !!v || '입력 하세요!',
				v => /.+@.+\..+/.test(v) || '유효한 이메일 형식이 아닙니다.',
			],
			codeRules: [
				v => !!v || '입력 하세요!',
				v => (v && v.length <= 3) || 'Name must be less than 10 characters',
			],
		};
	},
	computed: {
		...mapGetters('code', ['isCodes']),
		// mallCodes() {
		// 	return this.isCodes.filter(code => code.labels.includes('CODE_MALL'));
		// },
		bankCodes() {
			return this.isCodes.filter(code => code.labels.includes('CODE_BANK'));
		},
		streetMallCodes() {
			return this.isCodes.filter(code => code.labels.includes('CODE_MALL'));
		},
	},

	mounted() {},
	methods: {
		...mapActions('auth', ['SIGNUP']),
		checkInput() {
			this.username = this.username.replace(/[^a-zA-Z0-9]/g, '');
		},
		accountHolderInput() {
			// 입력값을 검증하여 특수 문자를 제거합니다.
			this.accountHolder = this.accountHolder.replace(/[^A-Za-z0-9가-힣\s]/g, '');
		},
		onKeyupNumeric(e) {
			// 숫자만 입력
			const value = e.target.value;
			const regExp = /[^0-9]/g;
			e.target.value = value.replace(regExp, '');
		},
		submit() {
			if (this.$refs.form.validate()) {
				// console.log('상가정보 ? ', this.vComCodes.id + ' : ' + this.vComCodes.codeName);
				this.isLoading = true;
				this.isSignUpDisabled = true;
				this.registerUser();
			}
			// this.$refs.form.validate()
		},
		// signUp(username, password) {},
		async registerUser() {
			let selBankName = '';
			if (this.vBankCode !== null) {
				selBankName = this.vBankCode.codeName;
			}
			const customerUser = {
				partnerMallId: this.partnerMallId,
				role: ['admin'],
				username: this.username,
				password: this.password,
				email: this.email,
				shopName: this.shopName,
				tellNumber: this.tellNumber,
				cellNumber: this.cellNumber,
				businessName: this.businessName,
				businessPerson: this.businessPerson,
				businessNumber: this.businessNumber,
				bankName: selBankName, // this.vBankCode.codeName,
				accountNumber: this.accountNumber,
				accountHolder: this.accountHolder,
				charger: this.charger,
				city: this.city,
				street: this.street,
				zipcode: this.zipcode,
				customerOnOffClass: this.customerOnOffClass,
				customerShopClass: this.customerShopClass,
				bulkYn: this.bulkYn,
				relativeCompany: this.relativeCompany,
				fax: this.fax,
				homepage: this.homepage,
				customerMemo: this.customerMemo,
				joinChannel: this.joinChannel,
				customerClient: this.customerClient.toString(),
				operationPeriod: this.operationPeriod,
				mainBuying: this.mainBuying.toString(),
			};

			try {
				const { data } = await this.SIGNUP(customerUser);
				this.logMessage = data;
				this.isLoading = false;
				// this.$store.commit('auth/SET_CONFIRM_AGREE', false);

				this.$store.commit('auth/SET_IS_REGISTRATED', true);

				// this.$router.push('/auth/completed');
				// this.initForm()
			} catch (error) {
				console.log(error.response);
				if (error.response.status === 400) {
					// this.logMessage = `${this.username} already exists`
					this.logMessage = error.response.data.message;
					this.isLoading = false;
					this.isSignUpDisabled = false;
				}
				if (error.response.status === 409) {
					// this.logMessage = `${this.username} already exists`
					this.logMessage = error.response.data.message;
					this.isLoading = false;
					this.isSignUpDisabled = false;
				}
			}
		},
		// async fetchAllCodes() {
		// 	const params = this.getRequestParams('');
		// 	const { data } = await fetchAllCodes(params);
		// 	const allCodes = data;
		// 	// console.log(allCodes)
		// 	this.mallCodes = allCodes.filter(code => code.labels.includes('CODE_MALL'));
		// 	this.bankCodes = allCodes.filter(code => code.labels.includes('CODE_BANK'));
		// 	console.log(this.mallCodes);
		// 	console.log(this.bankCodes);
		// },
		getRequestParams(codeClass) {
			const params = { codeClass };
			params.codeClass = codeClass;
			return params;
		},
		initForm() {
			this.username = '';
			this.password = '';
			this.email = '';
			// errorName = false;
			// errorEmail = false;
			// errorPassword = false;
		},
		execDaumPostcode() {
			this.postWindow = new window.daum.Postcode({
				onclose: state => {
					this.postOpen = false;
					// state는 우편번호 찾기 화면이 어떻게 닫혔는지에 대한 상태 변수 이며, 상세 설명은 아래 목록에서 확인하실 수 있습니다.
					if (state === 'FORCE_CLOSE') {
						// 사용자가 브라우저 닫기 버튼을 통해 팝업창을 닫았을 경우, 실행될 코드를 작성하는 부분입니다.
					} else if (state === 'COMPLETE_CLOSE') {
						// 사용자가 검색결과를 선택하여 팝업창이 닫혔을 경우, 실행될 코드를 작성하는 부분입니다.
						// oncomplete 콜백 함수가 실행 완료된 후에 실행됩니다.
						this.$refs.street.focus();
					}
				},
				oncomplete: data => {
					// console.log('선택 완료!');

					// 팝업에서 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.
					// 도로명 주소의 노출 규칙에 따라 주소를 조합한다.
					// 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
					let fullRoadAddr = data.roadAddress; // 도로명 주소 변수
					let extraRoadAddr = ''; // 도로명 조합형 주소 변수
					// 법정동명이 있을 경우 추가한다. (법정리는 제외)
					// 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.

					if (data.bname !== '' && /[동|로|가]$/g.test(data.bname)) {
						extraRoadAddr += data.bname;
					}

					// 건물명이 있고, 공동주택일 경우 추가한다.
					if (data.buildingName !== '' && data.apartment === 'Y') {
						extraRoadAddr += extraRoadAddr !== '' ? ', ' + data.buildingName : data.buildingName;
					}

					// 도로명, 지번 조합형 주소가 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
					if (extraRoadAddr !== '') {
						extraRoadAddr = ' (' + extraRoadAddr + ')';
					}

					// 도로명, 지번 주소의 유무에 따라 해당 조합형 주소를 추가한다.
					if (fullRoadAddr !== '') {
						fullRoadAddr += extraRoadAddr;
					}

					// 우편번호와 주소 정보를 해당 필드에 넣는다.
					// console.log('returnData ', data.zonecode)
					this.zipcode = data.zonecode; // 5자리 새우편번호 사용
					this.street = fullRoadAddr + ' ';
					this.city = data.jibunAddress + ' ';
					// 사용자가 '선택 안함'을 클릭한 경우, 예상 주소라는 표시를 해준다.

					if (data.autoRoadAddress) {
						// 예상되는 도로명 주소에 조합형 주소를 추가한다.
						const expRoadAddr = data.autoRoadAddress + extraRoadAddr;
						this.addr3 = '(예상 도로명 주소 : ' + expRoadAddr + ')';
					} else if (data.autoJibunAddress) {
						const expJibunAddr = data.autoJibunAddress;
						this.addr3 = '(예상 지번 주소 : ' + expJibunAddr + ')';
					} else {
						this.addr3 = '';
					}
				},
				theme: {
					searchBgColor: '#212121', // 검색창 배경색
					queryTextColor: '#FFFFFF', // 검색창 글자색
				},
				popupTitle: '우편번호 검색 팝업', // 팝업창 타이틀 설정 (영문,한글,숫자 모두 가능)
			});
			this.postWindow.open({ popupName: 'zipPopup' });
		},
		// signInProvider(provider) {},
		resetErrors() {
			this.errorName = false;
			this.errorEmail = false;
			this.errorPassword = false;
			this.errorProvider = false;
			this.errorProviderMessages = '';
		},
		// handleKeyUp(str) {
		// 	this.cellNumber = this.cellNumber + regExp(str);
		// },
	},
};
